export default __webpack_public_path__ + "static/media/feature-parking.ef30fbbe.svg";